import React from 'react';

import Header from "../components/Header";
import Footer from "../components/Footer";

export default function NotFound() {
    return (
        <>
            <Header />

            <h1>Page Not Found</h1>

            <Footer />
        </>
    );
}